import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { RenderForGlobalExchange } from 'components/render/RenderByExchangeType';
import ToggleThemeSwitch from 'components/toggleThemeSwitch';
import { ChevronLeft } from 'styles/assets/icons';
import LanguageMenu from 'UIKit/LanguageMenu';

import styles from './styles.module.scss';

interface BackLinkHeaderProps {
  text: string;
  backLink?: string | null;
  onBackClick?: () => void;
  displayNoneBackLink?: boolean;
}

const BackLinkHeader = ({
  backLink = null,
  onBackClick = () => {},
  displayNoneBackLink = false,
  text = '',
}: BackLinkHeaderProps) => {
  const { t } = useTranslation();

  return (
    (<div className={styles.backLinkHeader} data-palette="BackLinkHeader">
      {!displayNoneBackLink && backLink && (
        <Link className={styles.backLink} to={backLink} data-testid="pageBackButton">
          <ChevronLeft className={styles.backIcon} />
          <span className={styles.backText}>{t('common:back')}</span>
        </Link>
      )}
      {!displayNoneBackLink && !backLink && (
        <div
          role="button"
          tabIndex={0}
          onKeyPress={() => {}}
          className={styles.backLink}
          onClick={onBackClick}
          data-testid="pageBackButton"
          data-palette="BackLinkHeader">
          <ChevronLeft className={styles.backIcon} />
          <span className={styles.backText}>{t('common:back')}</span>
        </div>
      )}
      {text && <div className={styles.middleText} data-palette="BackLinkHeader">{text}</div>}
      <div
        className={styles.actionsSection}
        style={{ marginLeft: displayNoneBackLink ? 'auto' : 'unset' }}
      >
        <RenderForGlobalExchange>
          <LanguageMenu />
        </RenderForGlobalExchange>
        <ToggleThemeSwitch />
      </div>
    </div>)
  );
};

export default BackLinkHeader;
